import React from "react";
import "./Card.css";

export default function Card({ image, type }) {
  return (
    <div className="card-wrapper">
      <div className="nft-type-wrapper">
        <div className="nft-type">{type}</div>
      </div>
      <div className="image-contain">
        <img src={image} alt="no" />
      </div>
      <div className="info">
        <div className="title">Amazing Digital Art</div>
        <div className="bids">15 BIDS</div>
        <div className="" style={{ marginTop: "12px" }}>
          Highest Bid
        </div>
        <div className="" style={{ color: "orange", marginTop: "4px" }}>
          1.5 Music
        </div>
      </div>
    </div>
  );
}
